/* unplugin-vue-components disabled */import script from "./CompanyInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyInformation.vue?vue&type=script&setup=true&lang=js"

import "./CompanyInformation.vue?vue&type=style&index=0&id=70e35571&lang=scss"

const __exports__ = script;

export default __exports__